import { Contact } from '../components/Contact';
import AboutContent from '../content/about.mdx';
import ExperienceContent from '../content/experience.mdx';
import ProjectsContent from '../content/projects.mdx';
import Education from '../content/education.mdx';

function Section({ children }: { children: React.ReactNode }) {
  return (
    <section className="resume-section">
      {children}
    </section>
  );
}

export function Home() {
  return (
    <main className="resume-container">
      <div id="resume-content">
        <Section>
          <h1 className="resume-title">
            프론트엔드 프로그래머, 조은솔입니다.
          </h1>
        </Section>

        <Contact/>

        <Section>
          <AboutContent/>
        </Section>

        <Section>
          <ExperienceContent/>
        </Section>

        <Section>
          <ProjectsContent/>
        </Section>

        <Section>
          <Education/>
        </Section>
      </div>
      <div>
      </div>
    </main>
  );
} 